import { configureStore, Middleware, EnhancedStore } from "@reduxjs/toolkit";
import createReducer from "./rootReducer";
import {
	createStateSyncMiddleware,
	initMessageListener,
} from "redux-state-sync";


const stateSyncConfig = {
	blacklist: [
		'member/openDialog',
		'settings/openDialog',
		'settings/openDialogUpgrade',
		'projects/openNewDialog',
		'projects/openEditDialog',
		'dialog/openDialog',
		'dialog/closeDialog',
		'message/showMessage',
		'message/hideMessage',
		'viewObject/openDialog',
		'viewObject/openProcessDialog',
		'viewObject/openObjectDialog',
		'viewObject/openVoxelTerrainDialog',
		'viewObject/openOrthoVoxelTerrainDialog',
		'viewObject/openIndexedPointDialog',
		'viewObject/openVoxelizedMeshDialog',
		'viewObject/openIndexedMeshDialog',
		'viewObject/openVoxelBlockModelDialog',
		'viewObject/openVoxelPointCloudDialog',
		'notificationPanel/data/addNotification',
		
	], 
  };

//const middlewares: any[]  = [createStateSyncMiddleware(stateSyncConfig)];

const middlewares: any[]  = [];

if (process.env.NODE_ENV === 'development') {
	const { logger } = require(`redux-logger`);

	middlewares.push(logger);
}

const AppStore = configureStore({
	reducer: createReducer(),
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false/*{
				ignoredActions: [
					'dialog/openDialog',
					'dialog/closeDialog',
					'message/showMessage',
					'message/hideMessage'
				]
			}*/
		})
		.concat(middlewares),
	devTools: process.env.NODE_ENV === 'development'
});

interface OValue {
    prop: string
}

interface ObjectType {
    [name: string]: OValue;
}

interface StoreObject extends EnhancedStore {
    asyncReducers: ObjectType
}

const store: StoreObject = {
    ...AppStore,
    asyncReducers: {}
};

export const injectReducer = (key: string, reducer: any) => {
	if (store.asyncReducers[key]) {
		return false;
	}
	store.asyncReducers[key] = reducer;
	store.replaceReducer(createReducer(store.asyncReducers));
	return store;
};

export type AppStore = typeof store
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']

export default store;